const initialState = {
  alertRules: [],
  total: 0,
  fleet: null,
  alertRulesQuery: [],
  alertRulesDevices: {
    devices: [],
    total: 0,
  },
};

export default function alertRulesReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ALERT_FLEET": {
      state = {
        ...state,
        fleet: action.payload,
      };
      return state;
    }
    case "SET_ALERT_RULES": {
      const { alertRules, total } = action.payload;
      state = {
        ...state,
        alertRules,
        total,
      };
      return state;
    }
    case "UPDATE_ALERT_RULE": {
      const updatedAlertRules = state.alertRules.map((alert) => {
        if (alert.id === action.payload.id) {
          return action.payload;
        }
        return alert;
      });
      state = {
        ...state,
        alertRules: updatedAlertRules,
      };
      return state;
    }
    case "CREATE_ALERT_RULE": {
      state = {
        ...state,
        alertRules: [...state.alertRules, action.payload],
      };
      return state;
    }
    case "DELETE_ALERT_RULE": {
      state = {
        ...state,
        alertRules: state.alertRules.filter(
          (alert) => alert.id !== action.payload
        ),
      };
      return state;
    }

    case "SET_ALERT_RULES_QUERY": {
      state = {
        ...state,
        alertRulesQuery: action.payload,
      };
      return state;
    }

    default:
      return state;
  }
}
